import axios from "./axios"

class Set {
  async device(device) {
    return axios()
      .post("/api/set/device", device)
      .catch(err => _$.error(err))
  }
  async action(payload) {
    return axios()
      .post("/api/set/action", payload)
      .catch(err => _$.error(err))
  }
  async updateDeviceProperty(payload) {
    return axios()
      .post("/api/set/device/update/property", payload)
      .catch(err => _$.error(err))
  }
  async setRecord(payload) {
    return axios()
      .post("/api/set/records", payload)
      .catch(err => _$.error(err))
  }
  async setCart(payload) {
    return axios()
      .post("/api/send/cart", payload)
      .catch(err => _$.error(err))
  }
}

export default new Set()
